import { parseJsonField } from "./parseStructure";

/**
 * Single layout mechanism: seat_map.rows
 * Each row = array of cells: null (aisle/empty) or { number: "12" }
 */

export function normalizeCell(cell) {
  if (cell == null) return null;
  if (typeof cell === "number" || typeof cell === "string") {
    const n = String(cell).trim();
    return n ? { number: n } : null;
  }
  if (typeof cell === "object" && cell.number != null) {
    return { number: String(cell.number) };
  }
  return null;
}

export function parseSeatMapRows(rows) {
  if (!Array.isArray(rows)) return [];
  return rows.map((row) =>
    Array.isArray(row) ? row.map(normalizeCell) : []
  );
}

function unwrapSeatMap(val) {
  let parsed = parseJsonField(val, null);
  if (typeof parsed === "string") {
    parsed = parseJsonField(parsed, null);
  }
  return parsed;
}

export function hasSeatMapRows(seatMap) {
  const map = unwrapSeatMap(seatMap);
  return Boolean(map?.rows?.length);
}

/** Read seat_map from structure — the only layout source. */
export function resolveSeatMap(structure) {
  if (!structure || typeof structure !== "object") return [];

  const seatMap = unwrapSeatMap(structure.seat_map);
  if (!seatMap) return [];

  if (Array.isArray(seatMap)) {
    return parseSeatMapRows(seatMap);
  }

  if (seatMap?.rows?.length) {
    return parseSeatMapRows(seatMap.rows);
  }

  return [];
}
